export const collectionNodes = `
nodes {
  averagePrice
  bannerUrl
  candyMachineAddresses
  collectionKey
  createdAt
  creatorId
  creatorEmail
  description
  discord
  disputedMessage
  documentation
  endpoint
  facebook
  floorPrice
  id
  instagram
  isCurated
  isDerivative
  isNsfw
  items
  youtube
  website
  atlas3
  subber
  twitch
  whitepaper
  volumeTotal
  volumePast7d
  volumePast24h
  volumeModifiedAt
  verifeyed
  twitter
  tiktok
  thumbnailUrl
  telegram
  team
  tags
  state
  soloVerified
  soloUsername
  soloImageUrl
  name
  roadmap
  modifiedAt
  mintListUrl
  medium
  listed
  links
  }
`
export const draftNodes = `
nodes {
  youtube
  whitepaper
  collectionKey
  website
  volumeTotal
  volumePast7d
  volumePast24h
  volumeModifiedAt
  verifeyed
  twitter
  tiktok
  thumbnailUrl
  telegram
  team
  tags
  state
  soloVerified
  soloImageUrl
  soloUsername
  roadmap
  name
  modifiedAt
  mintListUrl
  medium
  atlas3
  subber
  twitch
  links
  listed
  items
  isNsfw
  isCurated
  isDerivative
  instagram
  id
  floorPrice
  facebook
  averagePrice
  bannerUrl
  createdAt
  candyMachineAddresses
  creatorId
  creatorEmail
  discord
  description
  disputedMessage
  documentation
  endpoint
  }
`

export const mintCalenderNodes = `
nodes {
  atlas3GiveawayUrl
  blockchain
  collectionId
  createdAt
  creatorEmail
  creatorId
  description
  discord
  id
  isApproved
  isOwn
  website
  upvoteCount
  updatedAt
  twitter
  thumbnailUrl
  supply
  subberPresaleUrl
  subberGiveawayUrl
  source
  price
  name
  logoUrl
  launchpadUrl
  launchDate
  isRejected
  twitterImageProfileUrl
  twitterFollowers
}
`

export const deletedNodes = `
nodes {
  youtube
  whitepaper
  website
  volumeTotal
  volumePast7d
  volumePast24h
  volumeModifiedAt
  verifeyed
  twitter
  tiktok
  atlas3
  subber
  twitch
  thumbnailUrl
  telegram
  team
  tags
  state
  soloVerified
  soloImageUrl
  soloUsername
  roadmap
  name
  modifiedAt
  mintListUrl
  medium
  links
  listed
  items
  isNsfw
  isCurated
  isDerivative
  instagram
  id
  floorPrice
  facebook
  averagePrice
  bannerUrl
  createdAt
  candyMachineAddresses
  creatorId
  discord
  description
  disputedMessage
  documentation
  endpoint
}
`
export const ordinalUpdatedCollectionNodes = `
nodes{
  averagePrice
  averagePriceDelta
  bannerUrl
  createdAt
  creatorId
  description
  discord
  documentation
  youtube
  whitepaper
  website
  volumeTotal
  volumePast7dDelta
  volumePast7d
  volumePast24hDelta
  volumePast24h
  volumeModifiedAt
  verifeyed
  twitter
  totalFloorPrice
  tiktok
  thumbnailUrl
  telegram
  team
  state
  roadmap
  name
  modifiedAt
  medium
  lowestInscriptionNum
  listed
  items
  isNsfw
  isFeatured
  isDerivative
  instagram
  id
  highestInscriptionNum
  floorPriceDelta
  floorPrice
  facebook
  collectionId
  okx_slug
  me_slug
  ordinalswallet_slug
}
`

export const ordinalDraftNodes = `
nodes{
  averagePrice
  averagePriceDelta
  bannerUrl
  createdAt
  creatorId
  description
  discord
  documentation
  youtube
  whitepaper
  website
  volumeTotal
  volumePast7dDelta
  volumePast7d
  volumePast24hDelta
  volumePast24h
  volumeModifiedAt
  verifeyed
  twitter
  totalFloorPrice
  tiktok
  thumbnailUrl
  telegram
  team
  state
  roadmap
  name
  modifiedAt
  medium
  lowestInscriptionNum
  listed
  items
  isNsfw
  isFeatured
  isDerivative
  instagram
  id
  highestInscriptionNum
  floorPriceDelta
  floorPrice
  facebook
}`


export const ordinalCollectionNodes = `
nodes{
  averagePrice
  averagePriceDelta
  bannerUrl
  createdAt
  creatorId
  description
  discord
  documentation
  youtube
  whitepaper
  website
  volumeTotal
  volumePast7dDelta
  volumePast7d
  volumePast24hDelta
  volumePast24h
  volumeModifiedAt
  verifeyed
  twitter
  totalFloorPrice
  tiktok
  thumbnailUrl
  telegram
  team
  state
  roadmap
  name
  modifiedAt
  medium
  lowestInscriptionNum
  listed
  items
  isNsfw
  isFeatured
  isDerivative
  instagram
  id
  highestInscriptionNum
  floorPriceDelta
  floorPrice
  facebook
  okx_slug
  me_slug
  ordinalswallet_slug
}
`